import React from "react";
import logo from "../images/logo.webp";
import "../css/PageLoader.css";

const PageLoader = ({ text = "Preparing something beautiful..." }) => {
  return (
    <div
      className="page-loader"
      role="status"
      aria-live="polite"
      aria-label={text}
    >
      <div className="loader-card">
        <div className="loader-emblem" aria-hidden="true">
          <span className="loader-orbit loader-orbit-outer" />
          <span className="loader-orbit loader-orbit-inner" />
          <img
            className="loader-logo"
            src={logo}
            alt=""
            decoding="async"
          />
        </div>

        <div className="loader-copy">
          <span className="loader-brand">Graphe Weddings</span>
          <span className="loader-divider" aria-hidden="true" />
          <p>{text}</p>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
